<template>
   <div class="panel-middle">
      <div class="row">
         <div class="col">
            <div class="form-group">
               <div class="custom-label">{{ $static('landing-editor.landing-title', 'Назва лендінгу') }}</div>
               <input type="text" v-if="basicLang" class="form-control custom-input" v-model="editedLanding.text"
                  :placeholder="$static('landing-editor.landing-title-placehold', 'Головна1')">
               <input type="text" v-else class="form-control custom-input" v-model="translateLandingText"
                  @update:modelValue="e => setTranslate('text', e)"
                  :placeholder="$static('landing-editor.landing-title-placehold', 'maidfdsf')">
            </div>
         </div>
      </div>

      <div class="row">
         <div class="col">
            <div class="form-group">
               <div class="custom-label">{{ $static('landing-editor.landing-url', 'URL лендінгу') }}</div>
               <input type="text" class="form-control custom-input" v-model="editedLanding.url" placeholder="home">
            </div>
         </div>
      </div>

      <div class="row">
         <div class="col">
            <div class="form-group">
               <div class="custom-label">{{ $static('landing-editor.landing-content-markup', 'Верстка лендінгу') }}
               </div>
               <div class="custom-editor-holder custom-pages-editor" v-if="basicLang">
                  <editor v-model="editedLanding.content" :placeholder="HTML" :small="false"></editor>
               </div>
               <div class="custom-editor-holder custom-pages-editor" v-else>
                  <editor :small="false" :placeholder="HTML" v-model="translateLandingContent"
                     @update:modelValue="e => setTranslate('content', e)"></editor>
               </div>
            </div>
         </div>
      </div>

      <!-- <div class="row">
         <div class="col">
            <div class="form-group">
               <div class="custom-label">{{ $static('landing-editor.landing-content-styles', 'Стилі лендінгу') }}</div>
               <div class="custom-editor-holder custom-pages-editor" v-if="basicLang">
                  <editor v-model="editedLanding.content" :small="false"></editor>
               </div>
               <div class="custom-editor-holder custom-pages-editor" v-else>
                  <editor :small="false" :placeholder="CSS" v-model="translateLandingContent"
                     @update:modelValue="e => setTranslate('content', e)"></editor>
               </div>
            </div>
         </div>
      </div> -->

   </div>

   <div class="panel-bottom">
      <button class="transparent-btn default-btn back_trigger" @click="$emit('cancel')">
         <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
      </button>
      <button class="default-btn btn-accent" @click="$emit('save', this.editedLanding)">
         <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
      </button>
   </div>
</template>

<script>
import api from '@/api'
import Editor from './Editor';

export default {
   name: 'LandingEditor',
   components: { Editor },
   emits: ['cancel', 'save'],
   props: ['landingData', 'lang'],
   data() {
      return {
         isLoading: false,
         editedLanding: JSON.parse(JSON.stringify(this.landingData))
      }
   },

   computed: {
      basicLang() {
         return this.lang === ''
      },
      translateLandingContent: {
         get() {
            return this.lang && this.editedLanding && this.editedLanding.translate && this.editedLanding.translate[this.lang] && this.editedLanding.translate[this.lang]["content"] ? this.editedLanding.translate[this.lang]["content"] : ""
         },
      },
      translateLandingText: {
         get() {
            return this.lang && this.editedLanding && this.editedLanding.translate && this.editedLanding.translate[this.lang] && this.editedLanding.translate[this.lang]["text"] ? this.editedLanding.translate[this.lang]["text"] : ""
         },
      },
   },

   methods: {
      setTranslate(key, value) {
         if (!this.editedLanding.translate || Array.isArray(this.editedLanding.translate)) {
            this.editedLanding.translate = {}
         }
         if (!this.editedLanding.translate[this.lang]) {
            this.editedLanding.translate[this.lang] = {}
         }
         this.editedLanding.translate[this.lang][key] = value
      }
   },
   watch: {
      landingData() {
         this.editedLanding = JSON.parse(JSON.stringify(this.landingData))

      }
   }
}
</script>